












import { Component, Vue } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  // TODO: Upload all email images directly to server and use an absolute link on the templates
  // TODO: Update the email templates and send to Scott to put with API
}
